import React from 'react'
import { withIcon } from '../../withIcon'

function GoogleIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.1431 4.36205C7.88171 3.02885 10.0231 2.3287 12.2135 2.37731C14.4039 2.42592 16.5122 3.22036 18.1899 4.62938C18.4543 4.85136 18.4886 5.2456 18.2666 5.50993C18.0446 5.77426 17.6504 5.80858 17.3861 5.58659C15.9262 4.36057 14.0917 3.6693 12.1858 3.627C10.2799 3.58471 8.41655 4.19393 6.90374 5.35398C5.39092 6.51404 4.31916 8.15552 3.86554 10.0072C3.41192 11.8588 3.60361 13.8098 4.40892 15.5377C5.21423 17.2657 6.58496 18.6672 8.29462 19.5107C10.0043 20.3541 11.9505 20.589 13.8118 20.1766C15.673 19.7642 17.3379 18.7291 18.5312 17.2424C19.5937 15.9188 20.2257 14.3078 20.3517 12.625H13C12.6548 12.625 12.375 12.3452 12.375 12C12.375 11.6548 12.6548 11.375 13 11.375H21C21.1658 11.375 21.3247 11.4408 21.4419 11.558C21.5592 11.6753 21.625 11.8342 21.625 12C21.625 14.1909 20.8775 16.3163 19.506 18.0249C18.1346 19.7335 16.2213 20.923 14.0822 21.397C11.9432 21.871 9.70641 21.601 7.74158 20.6317C5.77675 19.6623 4.20142 18.0516 3.27592 16.0658C2.35042 14.0799 2.13012 11.8377 2.65144 9.70973C3.17276 7.58172 4.40449 5.69525 6.1431 4.36205Z" fill={color}/>
    </svg>
  )
}

export default withIcon(GoogleIcon)
